/* eslint-disable no-debugger */
import firebase from 'firebase/app';
import db from '../connection';

export const quizFunctions = {
  created() {
    dataLayer.push({ event: "typeQuizTagCalls" });

    document.title = this.title;

    document.getElementById("socialTitle").content = this.title;
    document.getElementById(
      "socialDescription"
    ).content = this.share_description;
  },

  computed: {
    leaderboardUrl () {
      const url = this.$route.path.split('/').filter(a => a);
      url.push( 'leaderboard' );
      return '/' + url.join('/');
    },

    quizContainerClasses () {
      return this.$route.path.split('/').filter(a => a).map(path => `${path}-container`).join(' ');
    },

    lastQuestion () {
      return this.questionIndex === this.quiz.questions.length;
    }
  },
  
  methods: {

    home_content_change: function($event, index, direction) {
      if (direction === "in") {
        $event.target
          .querySelector("h2")
          .classList.add(this.types.sections[index].background_colour + "_txt");

        this.active_section = index;
        this.active_title = this.types.sections[index].section_title
        this.active_image = this.types.sections[index].knockout_image;
        this.active_colour = this.types.sections[index].background_colour;
      } else {
        $event.target
          .querySelector("h2")
          .classList.remove(
            this.types.sections[index].background_colour + "_txt"
          );

        this.active_section = "-1";
        this.active_image = this.active_image_default;
        this.active_colour = this.active_colour_default;
      }
    },
    // Go to next question
    next: function() {
      this.questionIndex++;

      if (this.lastQuestion) {
        this.score();

        if (!this.hide_form && 'toggleModal' in this.$refs) {
          this.$refs.modal.toggleModal(750);
          this.$refs.modal.setWinningType(this.winning_title);
        }
      } else {
        let questionNum = this.questionIndex + 1;
        dataLayer.push({
          event: "type-quiz-next",
          "type-question": this.$route.name + " | " + questionNum,
        });
      }
    },
    // Go to previous question
    prev: function() {
      if (this.questionIndex > 0) {
        this.questionIndex--;
      } else {
        this.quiz_hidden = true;
      }
    },

    score: function() {
      //find the highest occurence in responses
      var modeMap = {};
      var maxEl = this.userResponses[0],
        maxCount = 1;
      for (var i = 0; i < this.userResponses.length; i++) {
        var el = this.userResponses[i],
          el_multiple = new Array();

        if (el.indexOf(",") > -1) {
          el_multiple = el.split(",");
        } else {
          el_multiple.push(el);
        }

        for (var j = 0; j < el_multiple.length; j++) {
          if (modeMap[el_multiple[j]] == null) modeMap[el_multiple[j]] = 1;
          else modeMap[el_multiple[j]]++;
          if (modeMap[el_multiple[j]] > maxCount) {
            maxEl = el_multiple[j];
            maxCount = modeMap[el_multiple[j]];
          }
        }
      }
      if (
        maxEl !== undefined &&
        this.questionIndex === this.quiz.questions.length
      ) {
        this.winning_colour = this.types.sections[maxEl].background_colour;
        this.winning_text_colour = this.types.sections[maxEl].text_colour;
        this.winning_image = this.types.sections[maxEl].image;
        this.winning_svg_icon = this.types.sections[maxEl].svg_icon;
        this.winning_title = this.types.sections[maxEl].section_title;
        this.content_display = this.types.sections[maxEl].winner_content;
        this.asset_redirect = this.types.sections[maxEl].download_pdf;
        this.winning_attributes = this.types.sections[maxEl].section_attributes
        this.winning_products = this.types.sections[maxEl].products;
        this.winning_services = this.types.sections[maxEl].resources;
        this.landing_page_url = this.types.sections[maxEl].landing_page_url;
        this.winning_description = this.types.sections[maxEl].section_description;

        // if (typeof this.share_url !== 'undefined') {
        //   addthis.update('share', 'url', this.share_url);
        // }
        // addthis.update('share', 'title', this.types.sections[maxEl].social_description);
        // addthis.update('share', 'description', this.types.sections[maxEl].social_description);
        

        dataLayer.push({
          event: "type-quiz-result",
          "type-result":
            this.$route.name + " | " + this.types.sections[maxEl].section_title,
        });

        return true;
      }
    },
    download_link_clicked: function() {
      this.showForm = true;
    },
    start_over: function() {
      Object.assign(this.$data, this.defaultQuizData());

      let inputElements = document.querySelectorAll("input, select");

      for (var i = 0; i < inputElements.length; i++) {
        if (inputElements[i].type !== "hidden") {
          inputElements[i].value = "";
        }
        if (inputElements[i].type !== "checbox") {
          inputElements[i].checked = false;
        }
        if (
          inputElements[i].type !== "hidden" &&
          inputElements[i].tagName !== "SELECT"
        ) {
          inputElements[i].parentNode.classList.remove("has-value");
        }
      }

      // Reset the Form element, so we don't get the thank you message.
      let hideFormClasses = document.getElementsByClassName("hide-form-submit");
      for (i = 0; i < hideFormClasses.length; i++) {
        hideFormClasses[i].classList.remove("hide");
      }

      let showFormClasses = document.getElementsByClassName("form-thankyou");
      for (i = 0; i < showFormClasses.length; i++) {
        showFormClasses[i].classList.add("hide");
      }
    },
    back: function() {
      if (this.showForm === true) {
        this.showForm = false;
      } else {
        this.questionIndex = this.quiz.questions.length - 1;
      }
    },

    submitQuizResults() {
      this.next();

      if ( 'quiz' in this.$route.query && this.$route.query.quiz === '0' ) {
          return;
      }

      // do not submit to the database if not learner type quiz
      if ( ! this.isLearnerType && ! this.isAnimalType ) {
        return;
      }
      
      const data = {
          learnerType: this.winning_title
      };
      
      let eventName = '';
      
      // pass along the event param if applicable
      if ( 'eventId' in this.$route.params ) {
          eventName = this.$route.params.eventId;
      }
      
      data['event'] = eventName;
      data['createdAt'] = firebase.firestore.FieldValue.serverTimestamp();
      
      db.collection( 'quizSubmissions' ).add( data )
          .then(docRef => {
              // console.log("Document written with ID: ", docRef.id);
          })
          .catch(error => {
              console.error("Error adding document: ", error);
          });
    },
  }
};
